// extracted by mini-css-extract-plugin
export default {"root":"styles_root__NjtY1","brands":"styles_brands__KUIJc","wideBrands":"styles_wideBrands__EKZJm","brandsMobile":"styles_brandsMobile__Nkh3X"};